const { applicationTemplateType } = require('@nsr/applicant-apply-shared/src/constants/common');
const DA_LIST_MAX_ROWS = 15000;

const CONSTANTS = {
    gridSpacing: 3,
    archiveErrorType: {
        supplemental: 'supplemental',
        application: 'application',
    },
    autosaveStatuses: {
        ERROR: 'ERROR',
        INITIAL: 'INITIAL',
        SAVED: 'SAVED',
        SAVING: 'SAVING',
    },
    fraudStatus: {
        fraud: 'FRAUD',
        potential: 'POTENTIAL',
        noFraud: 'NOFRAUD',
        retry: 'RETRYFRAUD'
    },
    applicationDecisionStatus: {
        admitted: 'Admitted',
        declined: 'Declined',
        waitlist: 'Waitlist',
        conditionalAdmit: 'Conditional admit'
    },
    applicationOfferStatus: {
        accepted: 'Accepted',
        declined: 'Declined',
        conditionsCompleted: 'Conditions Completed'
    },
    applicationProcessingStatus: {
        importError: 'IMPORT_ERROR',
        personCheck: 'PERSON_CHECK',
        personError: 'PERSON_ERROR',
        pending: 'PENDING',
        error: 'ERROR',
        onHold: 'ON_HOLD',
        integrationError: 'INTEGRATION_ERROR',
        complete: 'COMPLETE',
        fraud: 'FRAUD'
    },
    maintenanceStatus: {
        NORMAL: 'normal',
        ACTIVE: 'active',
        SCHEDULED: 'scheduled',
        WARNING_WINDOW: 'warning_window',
        INACTIVE: 'inactive',
        DISABLED: 'disabled',
    },
    applicationStatusSummary: {
        processed: 'processed',
        fraud: 'fraud',
        pending: 'pending',
        needAttention: 'needAttention',
        importError: 'importError'
    },
    applicationProcessingEmailSubjectMaxCharacters: 200,
    applicationProcessingEmailContentMaxCharacters: 5000,
    inquiryPageModes: {
        personal: 'inquiryPersonal',
        student: 'inquiryStudent',
        program: 'inquiryProgram',
        loading: 'loading',
        confirm: 'inquiryConfirm',
    },
    communicationTypes: {
        email: 'email',
        text: 'textMessage',
    },
    communicateEmailSendStatus: {
        accepted: 'ACCEPTED',
        failed: 'FAILED',
        postponed: 'POSTPONED ',
    },
    inquiryTypes: {
        info: 'infoRequested',
        app: 'readyToApply',
    },
    timeout: {
        inquiryTimeout: 1000 * 60 * 15,
        recaptchaTimeout: 1000 * 60 * 2,
        sessionTimeout: 1000 * 60 * 15, // 15 minutes
        warningThreshold: 1000 * 30, // 30 seconds
        countdownDuration: 30 // 30 seconds
    },
    phoneCodes: {
        countryList: ['US', 'CA'],
    },
    applicationFeeAssignmentType: {
        all: 'all',
        query: 'query'
    },
    applicationFeeNameMaxCharacters: 50,
    applicationFormDialogType: {
        rename: 'rename',
        new: 'new',
        duplicate: 'duplicate'
    },
    applicationFormFilterMode: {
        published: 'PUBLISHED',
        editpublished: 'EDITPUBLISHED',
        draft: 'DRAFT',
        archived: 'ARCHIVED',
        all: 'ALL'
    },
    applicationFormStatusMessages: {
        PUBLISHED: 'appDesignStatusPublished',
        EDITPUBLISHED: 'appDesignStatusDraftPublished',
        DRAFT: 'appDesignStatusDraft',
        ARCHIVED: 'appDesignStatusArchived'
    },
    columnWidthOptions: {
        regular: 'regular',
        extended: 'extended'
    },
    // Do not change the values for appTemplateControlTypes
    appTemplateControlTypes: {
        page: 'page',
        section: 'section',
        group: 'group',
        question: 'question',
    },
    templateDisplayNameMaxCharacters: 100,
    templateSourceMaxCharacters: 50,
    apiErrors: {
        templateCannotBeNull: { errorCode: 'template-cannot-be-null', formatMessageId: 'applicationProcessingTemplateErrorNullTemplate' },
        templateMissingSettings: { errorCode: 'no-template-settings', formatMessageId: 'applicationProcessingTemplateErrorNoSettings' },
        templateMissingImportCode: { errorCode: 'no-template-code', formatMessageId: 'applicationProcessingTemplateErrorNoSource' },
        templateImportCodeTooLong: { errorCode: 'template-code-too-long', formatMessageId: 'applicationProcessingTemplateErrorSourceTooLong' },
        templateInvalidDefaultValue: { errorCode: 'invalid-default-value', formatMessageId: 'applicationProcessingTemplateErrorInvalidDefaultValue' },
        updateTemplateVersionError: { errorCode: 'version-error', formatMessageId: 'updateTemplateVersionErrorMessage' },
        updateTenantVersionError: { errorCode: 'tenant-version-error', formatMessageId: 'updateTenantVersionErrorMessage' },
        resendApplicationInvalidError: { errorCode: 'invalid-resend-application', formatMessageId: 'applicationProcessingInvalidResendError' },
        '401': { errorCode: '401', formatMessageId: 'applicationProcessingErrorUnauthorized' },
        '403': { errorCode: '403', formatMessageId: 'applicationProcessingErrorUnauthorized' },
        '404': { errorCode: '404', formatMessageId: 'applicationProcessingErrorNotFound' },
        '503': { errorCode: '503', formatMessageId: 'applicationProcessingErrorNotFound' }
    },
    dataAccessErrors: {
        '401': { errorCode: '401', formatMessageId: 'dataAccessNotAuthorized' },
        '403': { errorCode: '403', formatMessageId: 'dataAccessNotAuthorized' },
        '404': { errorCode: '404', formatMessageId: 'dataAccessDataNotLoaded' },
        '503': { errorCode: '503', formatMessageId: 'dataAccessDataNotLoaded' }
    },
    formNameMaxChars: 250,
    sectionNameMaxChars: 50,
    formats: {
        dateFormatStrings: ['MMMM D, Y', 'MMM D, Y', 'MM/D/YY', 'DD/MM/Y', 'MM/DD/Y'],
        month: 'MMMM',
    },
    controlTypes: {
        checkbox: 'checkbox',
        datepicker: 'datepicker',
        daterange: 'daterange',
        empty: 'empty',
        filteredsearch: 'filteredsearch',
        phone: 'phone',
        radiogroup: 'radiogroup',
        searchandselect: 'searchandselect',
        singlechoice: 'singlechoice',
        text: 'text',
        textarea: 'textarea',
        upload: 'upload',
    },
    maxQuestionsPerRow: 3,
    maxQuestionTextLength: 10000,
    pageNames: {
        review: 'review',
        submission: 'submission',
        supplementalItems: 'supplementalItems',
        supportingDocuments: 'supportingDocuments',
    },
    piimaskedValue: '[REDACTED]',
    piiMaskedValueRegexError: '[INVALIDREGEX]',
    supplementalQuestionDetails: {
        fileDefaultLimit: 1,
        fileMaxLimit: 5,
        fileSizeLimit: 10,
        fileRetentionDays: 10
    },
    allowedFileTypes: ['pdf'],
    fileStatus: {
        uploading: 'UPLOADING',
        uploaded: 'UPLOADED',
        error: 'ERROR',
    },
    questionTypes: [
        {
            type: 'text',
            icon: 'text',
            label: 'appDesignContentDialogTextfield',
            hoverMessage: 'appDesignHoverTextfield',
            isAps: false
        },
        {
            type: 'textarea',
            icon: 'italic',
            label: 'appDesignContentDialogTextarea',
            hoverMessage: 'appDesignHoverTextarea',
            isAps: false
        },
        {
            type: 'radiogroup',
            icon: 'circle',
            label: 'appDesignContentDialogRadioButton',
            hoverMessage: 'appDesignHoverRadiobutton',
            isAps: false
        },
        {
            type: 'singlechoice',
            icon: 'chevron-down',
            label: 'appDesignContentDialogDropdown',
            hoverMessage: 'appDesignHoverDropdown',
            isAps: false
        },
        {
            type: 'checkbox',
            icon: 'check-circle',
            label: 'appDesignContentDialogCheckbox',
            hoverMessage: 'appDesignHoverCheckbox',
            isAps: false
        },
        {
            type: 'searchandselect',
            icon: 'search',
            label: 'appDesignContentDialogSearchAndSelect',
            hoverMessage: 'appDesignHoverSearchAndSelect',
            isAps: true
        },
        {
            type: 'datepicker',
            icon: 'calendar',
            label: 'appDesignContentDialogDate',
            hoverMessage: 'appDesignHoverDate',
            isAps: false
        },
        {
            type: 'daterange',
            icon: 'calendar-grid',
            label: 'appDesignContentDialogDateRange',
            hoverMessage: 'appDesignHoverDateRange',
            isAps: false
        },
        {
            type: 'phone',
            icon: 'phone',
            label: 'appDesignContentDialogPhone',
            hoverMessage: 'appDesignHoverPhone',
            isAps: false
        },
        {
            type: 'filteredsearch',
            icon: 'filter',
            label: 'appDesignContentDialogFilteredSearch',
            hoverMessage: 'appDesignHoverFilteredSearch',
            isAps: true
        },
    ],
    radioDialog: {
        maxOptions: 5,
    },
    retentionIntervals: [
        { label: 'adminProspectsRetentionPeriodDialogDays', value: 'days' },
        { label: 'adminProspectsRetentionPeriodDialogWeeks', value: 'weeks' },
        { label: 'adminProspectsRetentionPeriodDialogMonths', value: 'months' },
        { label: 'adminProspectsRetentionPeriodDialogYears', value: 'years' }
    ],
    filteredSearch: {
        maxOptions: 6,
        maxCharacters: 30,
    },
    addNewPageType: {
        welcome: 'WELCOME PAGE',
        confirmation: 'CONFIRMATION PAGE',
        form: 'FORM PAGE',
        supplemental: 'SUPPLEMENTAL PAGE'
    },
    adminMenuItems: {
        configuration: 'configuration',
        editForm: 'editForm',
        home: 'home',
        notifications: 'notifications',
        submissions: 'submissions',
        themeEditor: 'themeEditor',
    },
    repromptTypes: {
        email: 'email',
        phone: 'phone',
        both: 'both',
    },
    applicationFormStatuses: {
        NOTSTARTED: 'NOTSTARTED',
        STARTED: 'STARTED',
        SUBMITTED: 'SUBMITTED',
        INCOMPLETE: 'INCOMPLETE',
        READONLY: 'READONLY',
        WITHDRAWN: 'WITHDRAWN'
    },
    applicationPageStatuses: {
        COMPLETED: 'COMPLETED',
        NOTCOMPLETED: 'NOTCOMPLETED',
    },
    applicationTemplateRuleStatus: {
        ACTIVE: 'ACTIVE',
        INACTIVE: 'INACTIVE'
    },
    questionPossibleValueTypes: {
        static: 'static',
        dynamic: 'dynamic',
    },
    recaptchaActions: {
        retrieve: 'RETRIEVE',
        inquiry: 'INQUIRY',
        resend: 'RESEND'
    },
    applicationResponseStatus: {
        complete: 'COMPLETE',
        incomplete: 'INCOMPLETE',
    },
    applicationRequiredPersonMappings: {
        firstname: '/name/firstName',
        lastname: '/name/lastName',
        emails: '/[emails]/address',
    },
    inquiryRequiredPersonMappings: {
        firstname: '/firstName',
        lastname: '/lastName',
        emails: '/[emails]/address',
    },
    prospectEmailDestinationPaths: [
        '/[emails]/address'
    ],
    applicationDefaultPersonalizationFields: [
        { id: 'first-name', destinationAttributePath: '/name/firstName', model: 'apply-applications' },
        { id: 'last-name', destinationAttributePath: '/name/lastName', model: 'apply-applications' },
        { id: 'email', destinationAttributePath: '/[emails]/address', model: 'apply-applications' },
        { id: 'phone-number', destinationAttributePath: '/[phones]/number', model: 'apply-applications' },
        { id: 'first-name', destinationAttributePath: '/firstName', model: 'apply-prospect-inquiries' },
        { id: 'last-name', destinationAttributePath: '/lastName', model: 'apply-prospect-inquiries' },
        { id: 'email', destinationAttributePath: '/[emails]/address', model: 'apply-prospect-inquiries' },
        { id: 'phone-number', destinationAttributePath: '/phone/number', model: 'apply-prospect-inquiries' }
    ],
    supplementalItemTypes: {
        display: 'display',
        form: 'suppForm',
        formWithUpload: 'suppFormUpload',
        upload: 'upload',
    },
    supplementalAssignmentTypes: {
        always: 'always',
        conditionally: 'conditionally',
    },
    supplementalRequiredTypes: {
        always: 'always',
        conditionally: 'conditionally',
        optional: 'optional',
    },
    supplementalStatus: {
        notReceived: 'notReceived',
        received: 'received',
        underReview: 'underReview',
        clarificationNeeded: 'clarificationNeeded',
        approved: 'approved',
        rejected: 'rejected',
    },
    discountStatus: {
        active: 'ACTIVE',
        scheduled: 'SCHEDULED',
        inactive: 'INACTIVE',
        all: 'ALL',
    },
    discountType: {
        amount: 'AMOUNT',
        percentage: 'PERCENTAGE',
    },
    textControlTypes: [
        {
            type: 'none',
            message: 'appDesginerControlTypeNone',
        },
        {
            type: 'text',
            message: 'appDesginerControlTypeText',
        },
        {
            type: 'email',
            message: 'appDesginerControlTypeEmail',
        },
        {
            type: 'url',
            message: 'appDesginerControlTypeUrl',
        },
        {
            type: 'number',
            message: 'appDesginerControlTypeNumber',
        },
        {
            type: 'password',
            message: 'appDesginerControlTypePassword',
        },
    ],
    maxLabelLength: 50,
    maxSupplementalDescriptionLength: 250,
    maxExternalDescriptionLength: 250,
    searchMaxLabelLength: 50,
    searchSelectDelay: 1000,
    applicationEmailSubjectMaxCharacters: 60,
    templateMessageKeys: {
        template: ['name', 'description'],
        settings: ['googleAnalyticsTracking', 'displayName', 'inactiveFormMessage', 'inactiveFormPageTitle', 'confirmationDescription', 'externalDescription', 'emailBody', 'emailSubject'],
        pages: ['title', 'description', 'help'],
        sections: ['title', 'help', 'description', 'repetitionTitle'],
        questions: ['label', 'help', 'startLabel', 'endLabel', 'regexCustomErrorMessage'],
        supplementalItems: ['help', 'completeDescription', 'noItemMessage', 'noItemDescription'],
        items: ['description', 'name']
    },
    templateRichTextMessageKeys: {
        template: [],
        settings: ['confirmationDescription', 'externalDescription', 'emailBody', 'emailSubject'],
        pages: ['description'],
        sections: ['description'],
        questions: [],
        supplementalItems: ['completeDescription', 'noItemDescription'],
        items: ['description']
    },
    startYear: 1920,
    globalSettings: {
        applicationFees: {
            paymentAccount: 'paymentAccount',
            discountCodes: 'discountCodes',
            feeCollection: 'feeCollection',
            feeCollectionOptions: {
                template: 'template',
                oneTimePerTerm: 'oneTimePerTerm',
                oneTimePerApplicant: 'oneTimePerApplicant'
            }
        },
        applicationRetrieval: 'applicationRetrievalSettings',
        applicationRetrievalRequiredFields: [
            'applicationRetrievalEmailSubject',
            'applicationRetrievalEmailBody'
        ],
        applicationRetrievalSettings: [
            { setting: 'applicationRetrievalName', defaultTextId: 'globalSettingsApplicationRetrievalName', descriptionId: 'globalSettingsApplicationRetrievalNameLabel', maxCharacters: 50 },
            { setting: 'applicationRetrievalInstructions', defaultTextId: 'globalSettingsApplicationRetrievalInstructions', descriptionId: 'globalSettingsApplicationRetrievalInstructionsLabel', maxCharacters: 50 },
            { setting: 'applicationRetrievalDescription', descriptionId: 'globalSettingsApplicationRetrievalDescriptionLabel', maxCharacters: 200 },
            { setting: 'applicationRetrievalConfirmation', descriptionId: 'globalSettingsApplicationRetrievalConfirmationLabel', maxCharacters: 300 },
            { setting: 'applicationRetrievalEmailSender', descriptionId: 'globalSettingsApplicationRetrievalEmailSender', maxCharacters: 300 },
            { setting: 'applicationRetrievalEmailSubject', descriptionId: 'globalSettingsApplicationRetrievalEmailSubject', maxCharacters: 60 },
            { setting: 'applicationRetrievalEmailBody', descriptionId: 'globalSettingsApplicationRetrievalEmailBody', maxCharacters: 500 },
            { setting: 'applicationRetrievalEmailLabel', defaultTextId: 'globalSettingsApplicationRetrievalEmailText', descriptionId: 'globalSettingsApplicationRetrievalEmailTextLabel', maxCharacters: 50 },
        ],
        applicationSettings: {
            supplementalUpload: 'supplementalUpload',
        },
        configurationSettings: {
            email: 'email'
        },
        generalSettings: {
            recaptcha: 'recaptcha',
            globalLanguage: 'globalLanguage',
            messages: 'messages',
            trustedURLs: 'trustedURLs',
            emailValidation: 'emailValidation',
            messagesToDisplay: [
                { setting: 'resendEmailLinkTextId', defaultTextId: 'globalSettingsResendEmailLinkTextId', descriptionId: 'globalSettingsResendEmailLinkTextIdLabel' },
                { setting: 'requiredFieldErrorTextId', defaultTextId: 'globalSettingsRequiredFieldErrorTextId', descriptionId: 'globalSettingsRequiredFieldErrorTextIdLabel' },
                { setting: 'incompleteApplicationTextId', defaultTextId: 'globalSettingsIncompleteApplicationTextId', descriptionId: 'globalSettingsIncompleteApplicationTextIdLabel' },
                { setting: 'invalidFormatErrorTextId', defaultTextId: 'globalSettingsInvalidFormatErrorTextId', descriptionId: 'globalSettingsInvalidFormatErrorTextIdLabel' },
                { setting: 'maxSearchOptionsWarningTextId', defaultTextId: 'globalSettingsMaxSearchOptionsWarningTextId', descriptionId: 'globalSettingsMaxSearchOptionsWarningTextIdLabel' },
                { setting: 'duplicateEmailTextId', defaultTextId: 'globalSettingsDuplicateEmailTextId', descriptionId: 'globalSettingsDuplicateEmailTextIdLabel' },
                { setting: 'noSearchResultsTextId', defaultTextId: 'globalSettingsNoSearchResultsTextId', descriptionId: 'globalSettingsNoSearchResultsTextIdLabel' },
                { setting: 'noResponseEnteredTextId', defaultTextId: 'globalSettingsNoResponseEnteredTextId', descriptionId: 'globalSettingsNoResponseEnteredTextIdLabel' },
                { setting: 'footerText', descriptionId: 'globalSettingsFooterTextLabel', maxCharacters: 200 }
                //{ setting: 'payConfirmationHeader', defaultTextId: 'globalSettingsPayConfirmationHeader', descriptionId: 'globalSettingsPayConfirmationHeaderLabel', maxCharacters: 50 },
                //{ setting: 'payConfirmationContent', defaultTextId: 'globalSettingsPayConfirmationContent', descriptionId: 'globalSettingsPayConfirmationContentLabel', maxCharacters: 250 },
                //{ setting: 'supplementalUploadMaxSizeTextId', defaultTextId: 'globalSettingsSupplementalUploadMaxSizeTextId', descriptionId: 'globalSettingsSupplementalUploadMaxSizeTextIdLabel' },
                //{ setting: 'archivedInquiryFormAccessMessageTextId', defaultTextId: 'globalSettingsArchivedInquiryFormAccessMessageTextId', descriptionId: 'globalSettingsArchivedInquiryFormAccessMessageTextIdLabel' },
                //{ setting: 'invalidEmailFormatTextId', defaultTextId: 'globalSettingsInvalidEmailFormatTextId', descriptionId: 'globalSettingsInvalidEmailFormatTextIdLabel' },               
            ]
        },
        globalTheme: 'globalTheme',
        integrationSettings: 'integrationSettings',
        optionallyRequiredFields: [
            {
                conditionField: 'recaptcha.recaptchaToggle',
                conditionValue: true,
                requiredFields: [
                    'recaptcha.recaptchaClientToken',
                    'recaptcha.recaptchaServerToken'
                ]
            }
        ],
        supplementalUploadSizeDefault: 5,
        supplementalUploadSizeMax: 5000,
        supplementalUploadSizeMin: 1,
        requiredFields: [
            'supplementalUploadMaxSize',
        ]
    },
    formSettings: {
        basicSettings: 'BasicSettings',
        supplementalItems: 'SupplementalItems',
        formAssignment: 'FormAssignment',
        shareForm: 'Share',
        applicationFee: 'ApplicationFee'
    },
    academicCatalogs: {
        programModel: 'academic-programs',
        model: 'academic-catalogs',
        attributes: [
            'id',
            'academicPrograms__ver__{id,title,code}',
            'title'
        ],
        sort: ['title'],
        filter: {
            id: {EQ: 'xx__filterid__xx'}
        }
    },
    emailVerificationStatus: {
        failed: 'FAILED',
        pending: 'PENDING',
        verified: 'VERIFIED'
    },
    supplementalItems: {
        itemTypes: {
            display: 'display',
            upload: 'upload',
            suppForm: 'suppForm',
            suppFormUpload: 'suppFormUpload'
        },
        assignmentTypes: {
            always: 'always',
            conditionally: 'conditionally',
        },
        requiredTypes: {
            always: 'always',
            conditionally: 'conditionally',
            optional: 'optional'
        },
        messages: {
            display: 'appDesignConfigurationSupplementalItemsDialogDisplay',
            upload: 'appDesignConfigurationSupplementalItemsDialogUpload',
            suppForm: 'appDesignConfigurationSupplementalItemsDialogSupplementalForm',
            suppFormUpload: 'appDesignConfigurationSupplementalItemsDialogSupplementalFormUpload',
        }
    },
    languagesPrefix: {
        langPrefix: 'languages_',
        regionPrefix: 'languageRegions_'
    },
    daAttributesForSelectionOptionsPreview: ['title', 'code', 'description'],
    eedmDestinationAttribute: {
        email: '/[emails]/address',
        customField: '/[additionalData]/[propertyValues]',
    },
    repeatingTypeFields: [
        '/[addresses]/type',
        '/[phones]/type',
        '/[emails]/type',
        '/name/[alternateNames]/alternateNameType',
        '/[credentials]/type',
        '/[alternativeCredentials]/type'
    ],
    relatedTypeFieldAttributes: {
        '/name/type': '/name/[alternateNames]/alternateNameType',
        '/name/[alternateNames]/alternateNameType': '/name/type'
    },
    eedmCustomFieldMaxLength: 50,
    eedmDestinationModel: {
        applyApplications: 'apply-applications',
        applyProspectInquiries: 'apply-prospect-inquiries',
    },
    applicationSourceTypes: {
        selectedValue: 'selectedValue',
        textValue: 'textValue',
    },
    templateValidationsDataType: {
        required: 'required',
        publishedFormAssociation: 'publishedFormAssociation',
        emailNotification: 'emailNotification',
        templateField: 'templateField',
        notRequired: 'notRequired'
    },
    applicationPaymentInformation: {
        transactionTypes: {
            authentication: 'A',
            sales: 'S',
        },
        paymentMethods: {
            creditCard: 'CC',
        },
        paymentStatus: {
            draft: 'DRAFT',
            started: 'STARTED',
            canceled: 'CANCELED',
            pending: 'PENDING',
            successful: 'SUCCESSFUL',
            failed: 'FAILED',
        },
        epsPaymentStatus: {
            inprogress: 'IN_PROGRESS',
            cancelled: 'CANCELLED',
            success: 'SUCCESS',
            failed: 'FAILED',
        }
    },
    paymentSettings: {
        processName: 'ApplyAppFee',
        processDescription: 'Apply Application Fee',
    },
    hedmAttributeTypes: {
        boolean: 'boolean',
        array: 'array',
        date: 'date',
        email: 'email',
        enum: 'enum',
        lookup: 'lookup',
        number: 'number',
        object: 'object',
        oneOf: 'oneOf',
        phone: 'phone',
        string: 'string',
    },
    maximumNumberOfApplicationFees: 10,
    applicantPaymentQueryParam: {
        key: 'showDialog',
        value: 'true'
    },
    reportsMenuItems: {
        communications: 'communications',
        errorsAdmin: 'errorsAdmin',
        errorsApplicant: 'errorsApplicant',
        errorsIntegration: 'errorsIntegration',
        errorsRecaptcha: 'errorsRecaptcha',
        paymentTransactions: 'paymentTransactions',
        submittedApplications: 'submittedApplications',
    },
    dateFormats: [
        'MM/dd/yyyy',
        'MM/d/yy',
        'dd/MM/yyyy',
        'dd/MM/y',
        'yyyy/MM/dd',
        'MM/dd/y',
    ],
    dateFormatsDisplay: [
        'MM/DD/YYYY',
        'MM/D/YY',
        'DD/MM/YYYY',
        'DD/MM/Y',
        'YYYY/MM/DD',
        'MM/DD/Y',
    ],
    defaultDateFormat: 'MM/dd/yyyy',
    defaultDateFormatDisplay: 'MM/DD/YYYY',
    currencies: ['AED', 'ALL', 'AMD', 'ARS', 'AUD', 'AZN', 'BGN', 'BHD', 'BND', 'BOB', 'BRL', 'BYR', 'BZD', 'CAD', 'CHF', 'CLP', 'CNY', 'COP', 'CRC',
        'CZK', 'DKK', 'DOP', 'DZD', 'EEK', 'EGP', 'ETB', 'EUR', 'GBP', 'GEL', 'GTQ', 'HKD', 'HNL', 'HRK', 'HUF', 'IDR', 'ILS', 'INR', 'IQD', 'IRR', 'ISK',
        'JMD', 'JOD', 'JPY', 'KES', 'KGS', 'KRW', 'KWD', 'KZT', 'LBP', 'LTL', 'LVL', 'LYD', 'MAD', 'MKD', 'MNT', 'MOP', 'MVR', 'MXN', 'MYR', 'NIO', 'NOK',
        'NZD', 'OMR', 'PAB', 'PEN', 'PHP', 'PKR', 'PLN', 'PYG', 'QAR', 'RON', 'RSD', 'RUB', 'SAR', 'SEK', 'SGD', 'SYP', 'THB', 'TND', 'TRY', 'TTD', 'TWD',
        'UAH', 'USD', 'UYU', 'UZS', 'VEF', 'VND', 'YER', 'ZAR', 'ZWL'],
    apiUrlKey: 'apiUrl',
    sortDirections: {
        ascending: 'asc',
        descending: 'desc'
    },

    dateRangePickerMinDateYearRange: 50,
    recaptchaErrorCodeMessages: {
        'missing-input-secret': 'reportsErrorsRecaptchaErrorsInvalidSecretKeyError',
        'invalid-input-secret': 'reportsErrorsRecaptchaErrorsInvalidSecretKeyError',
        'missing-input-response': 'reportsErrorsRecaptchaErrorsInvalidSiteKeyError',
        'invalid-input-response': 'reportsErrorsRecaptchaErrorsInvalidSiteKeyError',
        'bad-request': 'globalSettingsRecaptchaErrorBadRequest',
        'timeout-or-duplicate': 'globalSettingsRecaptchaErrorTimeoutOrDuplicate',
        'below-threshold': 'globalSettingsRecaptchaErrorsBelowThreshold',
        'server-error': 'reportsErrorsRecaptchaErrorsServerError',
        'invalid-site-key': 'globalSettingsRecaptchaInvalidSiteKeyError',
        'invalid-secret-key': 'globalsettingsRecaptchaInvalidSecretKeyError',
        'failed-to-communicate': 'globalSettingsRecaptchaErrorFailedToCommunicate',
        'invalid-keys': 'globalSettingsRecaptchaErrorInvalidKeyPair',
    },
    recaptchaErrorCodes: {
        invalidInputSecret: 'invalid-input-secret',
        belowThreshold: 'below-threshold',
        serverError: 'server-error',
        missingInputResponse: 'missing-input-response',
        invalidKeyPair: 'invalid-keys',
    },
    errorType: {
        recaptcha: 'recaptcha',
        general: 'general',
    },
    generalErrorCode: {
        retrieveThemeError: 'retrieve-theme-error',
        failedToFetchForm: 'failed-to-fetch-form',
        failedToStartApplication: 'failed-to-start-application',
        failedToValidateDiscountCode: 'failed-to-validate-discount-code',
        failedToSubmitApplication: 'failed-to-submit-application',
        dataAccessError: 'data-access-error',
        failedToRetrieveProspect: 'failed-to-retrieve-prospect',
        failedToResendEmail: 'failed-to-resend-email',
        failedToFetchTotalValueNumberAndPreviewForQuestion: 'failed-to-fetch-total-value-number-and-preview-for-question',
        failedToRetrieveAttributesForTheModel: 'failed-to-retrieve-attributes-for-the-model',
        fraudCheckFailed: 'fraud-check-failed'
    },
    applicationTemplateTypes: {
        online: 'online',
        import: 'import'
    },
    stagerMappingErrors: {
        duplicateProperties: 'duplicate-properties',
        invalidDateRangeString: 'invalid-date-range-string',
        invalidDateString: 'invalid-date-string',
        invalidMultiselect: 'multi-select-no-array',
        invalidPhoneObject: 'invalid-phone-object',
        invalidRepeatingSection: 'invalid-repeating-section',
        invalidSelectValue: 'invalid-select-value',
        invalidTemplateCode: 'invalid-template-code',
        invalidTextValue: 'invalid-text-value',
        missingTemplateCode: 'missing-template-code'
    },
    importFieldNameMaxCharacters: 350,
    apsTemplateStatus: {
        active: 'ACTIVE',
        archived: 'ARCHIVED',
        draft: 'DRAFT',
        inactive: 'INACTIVE'
    },
    apsTemplateStatusMessages: {
        ACTIVE: 'applicationProcessingActiveLabel',
        ARCHIVED: 'appDesignStatusArchived',
        DRAFT: 'appDesignStatusDraft',
        INACTIVE:'applicationProcessingInactive',
        PUBLISHED: 'applicationProcessingPublished'
    },
    piiEedmMappings: {
        'apply-applications': [
            '/[credentials]/value',
            '/citizenship/foreignTaxId',
            '/citizenship/visa/visaId',
            '/citizenship/visa/alienRegistrationNumber',
            '/citizenship/passportNumber',
            '/[disabilityTypes]',
            '/military/veteranFileNumber'
        ]
    },
    userRoles: {
        admin: 'apply_admin',
        piiRestricted: 'aps_pii_restricted'
    },
    userActions: {
        viewStagingRecord: {
            path: '/stagers',
            action: 'view-staging-records'
        },
        editStagingRecord: {
            path: '/stagers',
            action: 'edit-staging-records'
        },
        deleteStagingRecord: {
            path: '/stagers',
            action: 'delete-staging-records'
        },
        clearFraud: {
            path: '/applications',
            action: 'clear-fraud'
        },
        viewProcessingHistory: {
            path: '/applications',
            action: 'view-processing-history'
        },
        viewApplication: {
            path: '/applications',
            action: 'view-application'
        },
        editApplication: {
            path: '/applications',
            action: 'edit-application'
        },
        deleteApplication: {
            path: '/applications',
            action: 'delete-application'
        },
        resendApplication: {
            path: '/applications',
            action: 'resend-application'
        },
        unmaskPIIData: {
            path: '/applications',
            action: 'unmask-pii'
        },
        manageTemplate: {
            path: '/applicationtemplates',
            action: 'manage-template'
        },
        uploadTemplate: {
            path: '/applicationtemplates',
            action: 'upload-template'
        },
        exportTemplate: {
            path: '/applicationtemplates',
            action: 'export-template'
        },
        deleteTemplate: {
            path: '/applicationtemplates',
            action: 'delete-template'
        },
        editConfigurationSettings: {
            path: '/settings',
            action: 'edit-config-settings'
        },
        editAPIKeys: {
            path: '/settings',
            action: 'edit-api-keys'
        },
        sendApplicationEmail: {
            path: '/applications',
            action: 'send-email'
        },
        sendStagerEmail: {
            path: '/stagers',
            action: 'send-email'
        }
    },
    preSubmittedStatuses: ['NOTSTARTED','STARTED'],
    helpDocumentationUrl: 'https://resources.elluciancloud.com/bundle?labelkey=product-services-aps',
    virtualAdvisor: {
        zIndex: 99999,
    },
    statusLabelCollection: {
        COMPLETE: { messageId: 'applicationProcessingStatusComplete', labelType: 'success' },
        ERROR: { messageId: 'applicationProcessingStatusError', labelType: 'error' },
        IMPORT_ERROR: { messageId: 'applicationProcessingStatusImportError', labelType: 'error' },
        INTEGRATION_ERROR: { messageId: 'applicationProcessingStatusIntegrationError', labelType: 'error' },
        PENDING: { messageId: 'applicationProcessingStatusPending', labelType: 'pending' },
        PERSON_CHECK: { messageId: 'applicationProcessingStatusPersonCheck', labelType: 'pending' },
        PERSON_ERROR: { messageId: 'applicationProcessingStatusPersonError', labelType: 'error' },
        FRAUD: { messageId: 'applicationProcessingStatusFraud', labelType: 'error' },
        POTENTIAL: { messageId: 'applicationProcessingPotentialFraud', labelType: 'draft' },
        RETRYFRAUD: { messageId: 'applicationProcessingPotentialFraud', labelType: 'draft' },
        NOTSTARTED: { messageId: 'adminProspectsStatusNotStarted', labelType: 'pending' },
        READONLY: { messageId: 'adminProspectsStatusReadOnly', labelType: 'pending' },
        STARTED: { messageId: 'adminProspectsStatusStarted', labelType: 'pending' },
        SUBMITTED: { messageId: 'adminProspectsSubmitted', labelType: 'success' },
        WITHDRAWN: { messageId: 'adminProspectsStatusWithdrawn', labelType: 'pending' },
        infoRequested: { messageId: 'adminProspectsSubmitted', labelType: 'success' },
        readyToApply: { messageId: 'appDesignResponsesReadyToApply', labelType: 'success' }
    },
    curriculumCachedQuestions: [
        {
            key: 'term',
            keyPlural: 'terms',
            applicationAttributePath: '/enrollment/academicPeriod',
            inquiryAttributePath: '/entryAcademicPeriod'
        },
        {
            key: 'program',
            keyPlural: 'programs',
            applicationAttributePath: '/enrollment/[academicPrograms]',
            inquiryAttributePath: '/[academicPrograms]'
        },
        {
            key: 'level',
            keyPlural: 'levels',
            applicationAttributePath: '/enrollment/academicLevel',
            inquiryAttributePath: '/academicLevel'
        },
        {
            key: 'major',
            keyPlural: 'majors',
            applicationAttributePath: '/enrollment/major',
            inquiryAttributePath: '/major'
        },
        {
            key: 'location',
            keyPlural: 'locations',
            applicationAttributePath: '/enrollment/[campusLocations]',
            inquiryAttributePath: '/site'
        },
        {
            key: 'minor',
            keyPlural: 'minors',
            applicationAttributePath: '/enrollment/minor'
        },
        {
            key: 'concentration',
            keyPlural: 'concentrations',
            applicationAttributePath: '/enrollment/concentration'
        }
    ],
    contentPlaceholders: {
        appRetreivalLink: '{RetrievalLink}'
    },
    loginSources: {
        inquiry: 'inquiry',
        appRetreival: 'appRetrieval',
        mfaReset: 'mfaReset',
        uaePass: 'uaePass',
    },
    uaePassSuppliedFieldNames: [
        'firstName',
        'lastName',
        'email',
        'phone',
        'nationality',
        'gender',
        'emiratesId',
    ],
    majorDescriptionSelfServiceQuestionId: 'majorDescriptionSelfServiceId',
    preloadedStatePropWhitelist: [
        'api',
        'externalApplication',
        'applications',
        'virtualAdvisor',
        'recaptchaKey',
        'templates',
        'globalTheme',
        'templateTheme',
        'themeEditorAppId',
        'favicon',
        'featureSupported',
        'mfaReturnUrl',
        'user.phone',
        'user.id',
        'user.email',
        'user.firstName',
        'user.lastName',
        'user.nationality',
        'user.gender',
        'user.emiratesId',
        'user.uaePassUuid',
        'isUaePassAuthenticated',
        'uaePassSuppliedFields',
        'globalSettings.theme',
        'globalSettings.defaultLanguage',
        'globalSettings.settingMessages',
        'globalSettings.maintenanceStatus',
        'globalSettings.disabledLanguages',
        'globalSettings.generalSettings',
        'globalSettings.applicationRetrievalSettings',
        'globalSettings.recaptcha.recaptchaToggle',
        'globalSettings.recaptcha.recaptchaClientToken',
        'globalSettings.paymentSettings.paymentProvider',
        'globalSettings.paymentSettings.paymentSubProvider',
        'globalSettings.paymentSettings.currency',
        'globalSettings.applyPageTitle',
        'globalSettings.themeAppId',
        'globalSettings.supportedGraphqlModels',
        'globalSettings.supplementalItemStatus',
        'globalSettings.uaepassSettings',
        'uaePassError.messageId',
    ]
};

const validHedmAttributeTypesByControlType = (() => {
    const { controlTypes, hedmAttributeTypes } = CONSTANTS;
    const map = {};
    map[controlTypes.checkbox] = [hedmAttributeTypes.string, hedmAttributeTypes.enum, hedmAttributeTypes.lookup];
    map[controlTypes.datepicker] = [hedmAttributeTypes.date];
    map[controlTypes.daterange] = [hedmAttributeTypes.date];
    map[controlTypes.filteredsearch] = [hedmAttributeTypes.lookup];
    map[controlTypes.phone] = [hedmAttributeTypes.string, hedmAttributeTypes.phone];
    map[controlTypes.radiogroup] = [hedmAttributeTypes.enum, hedmAttributeTypes.string, hedmAttributeTypes.boolean];
    map[controlTypes.searchandselect] = [hedmAttributeTypes.enum, hedmAttributeTypes.string, hedmAttributeTypes.lookup];
    map[controlTypes.singlechoice] = [hedmAttributeTypes.enum, hedmAttributeTypes.string, hedmAttributeTypes.lookup];
    map[controlTypes.text] = [hedmAttributeTypes.string, hedmAttributeTypes.email, hedmAttributeTypes.phone, hedmAttributeTypes.number];
    map[controlTypes.textarea] = [hedmAttributeTypes.string];
    return map;
})();

const validationErrorType = {
    emptySettings: 'emptySettings',
    emptyQuestionLabel: 'emptyQuestionLabel',
    emptyDefaultCountry: 'emptyDefaultCountry',
    missingFieldGroupings: 'missingFieldGroupings',
    emptyPageTitle: 'emptyPageTitle',
    missingFormLink: 'missingFormLink',
    invalidRegexValue: 'invalidRegexValue',
    invalidStartEndYears: 'invalidStartEndYears',
    missingPersonMapping: 'missingPersonMapping'
};

const settingsType = {
    externalDescription: 'settings.externalDescription',
    confirmationDescription: 'settings.confirmationDescription',
    senderEmail: 'settings.senderEmail',
    emailSubject: 'settings.emailSubject',
    emailBody: 'settings.emailBody',
    applicationTemplateRules: 'settings.applicationTemplateRules',
    importCode: 'settings.importCode',
    displayName: 'settings.displayName',
    name: 'name'
};

CONSTANTS.templateValidations = [
    //All Template Types (Inquiry, Apply Apps, Import Apps, Supplementals)
    { name: settingsType.name, type: CONSTANTS.templateValidationsDataType.required, isRichText: false, hasError: false, validationErrorType: validationErrorType.emptySettings },
    { name: settingsType.importCode, type: CONSTANTS.templateValidationsDataType.required, isRichText: false, hasError: false, validationErrorType: validationErrorType.emptySettings },
    //Inquiry Forms        
    { templateType: applicationTemplateType.inquiry, name: settingsType.senderEmail, type: CONSTANTS.templateValidationsDataType.emailNotification, isRichText: false, hasError: false, validationErrorType: validationErrorType.emptySettings },
    { templateType: applicationTemplateType.inquiry, name: settingsType.emailSubject, type: CONSTANTS.templateValidationsDataType.emailNotification, isRichText: false, hasError: false, validationErrorType: validationErrorType.emptySettings },
    { templateType: applicationTemplateType.inquiry, name: settingsType.emailBody, type: CONSTANTS.templateValidationsDataType.emailNotification, isRichText: true, hasError: false, validationErrorType: validationErrorType.emptySettings },
    { templateType: applicationTemplateType.inquiry, name: settingsType.confirmationDescription, type: CONSTANTS.templateValidationsDataType.required, isRichText: true, hasError: false, validationErrorType: validationErrorType.emptySettings },
    //Apply Applications
    { templateType: applicationTemplateType.application, name: settingsType.displayName, type: CONSTANTS.templateValidationsDataType.required, isRichText: false, hasError: false, validationErrorType: validationErrorType.emptySettings, isImportTemplate: false },
    { templateType: applicationTemplateType.application, name: settingsType.senderEmail, type: CONSTANTS.templateValidationsDataType.emailNotification, isRichText: false, hasError: false, validationErrorType: validationErrorType.emptySettings, isImportTemplate: false },
    { templateType: applicationTemplateType.application, name: settingsType.emailSubject, type: CONSTANTS.templateValidationsDataType.emailNotification, isRichText: false, hasError: false, validationErrorType: validationErrorType.emptySettings, isImportTemplate: false },
    { templateType: applicationTemplateType.application, name: settingsType.emailBody, type: CONSTANTS.templateValidationsDataType.emailNotification, isRichText: true, hasError: false, validationErrorType: validationErrorType.emptySettings, isImportTemplate: false },
    { templateType: applicationTemplateType.application, name: settingsType.externalDescription, type: CONSTANTS.templateValidationsDataType.required, isRichText: true, hasError: false, validationErrorType: validationErrorType.emptySettings, isImportTemplate: false },
    { templateType: applicationTemplateType.application, name: settingsType.confirmationDescription, type: CONSTANTS.templateValidationsDataType.required, isRichText: true, hasError: false, validationErrorType: validationErrorType.emptySettings, isImportTemplate: false },
    //Legacy or Unused
    //{ templateType: applicationTemplateType.inquiry, name: settingsType.applicationTemplateRules, type: CONSTANTS.templateValidationsDataType.publishedFormAssociation, isRichText: true, hasError: false, validationErrorType: validationErrorType.emptySettings },
];

CONSTANTS.templatePageValidations = [
    //Empty Page Title 
    { valType: validationErrorType.emptyPageTitle, invalid: function (page) { return !page.title; } }
];

CONSTANTS.templateQuestionValidations = [
    //Empty Question Label
    { valType: validationErrorType.emptyQuestionLabel, invalid: function (q) { return q.type !== CONSTANTS.controlTypes.empty && !q.label; } },
    //Default Country on Phones
    { valType: validationErrorType.emptyDefaultCountry, invalid: function (q) { return q.type === CONSTANTS.controlTypes.phone && !q.defaultCountry; } },
    //DatePicker Start/EndRange
    { valType: validationErrorType.invalidStartEndYears, invalid: function (q) { return q.type === CONSTANTS.controlTypes.datepicker && q.startYear && q.endYear && q.startYear > q.endYear; } },
    //Regex Check
    {
        valType: validationErrorType.invalidRegexValue,
        invalid: function (q) {
            if (q.regexValidationExpression) {
                try {
                    RegExp(q.regexValidationExpression);
                    return false;
                } catch {
                    return true;
                }
            } else { return false; }
        }
    }
];

const templateErrorMessages = {
    'name': 'appDesignErrorNullName',
    'settings.externalDescription': 'appDesignErrorNullExternalDescription',
    'settings.confirmationDescription': 'appDesignErrorNullConfirmationDescription',
    'settings.senderEmail': 'appDesignErrorNullSenderEmail',
    'settings.emailSubject': 'appDesignErrorNullEmailSubject',
    'settings.emailBody': 'appDesignErrorNullEmailBody',
    'settings.applicationTemplateRules': 'appDesignErrorInvalidApplicationTemplateRules',
    'settings.displayName': 'appDesignErrorNullDisplayName',
    'missingFieldGroupings': 'appDesignErrorMissingFieldGroupings',
    'emptyDefaultCountry': 'appDesignErrorEmptyDefaultCountry',
    'emptyQuestionLabel': 'appDesignErrorEmptyQuestionLabel',
    'emptyPageTitle': 'appDesignErrorEmptyPageTitle',
    'missingFormLink': 'appDesignErrorEmailFormLink',
    'settings.importCode': 'appDesignErrorNullImportCode',
    'invalidRegexValue': 'appDesignErrorInvalidRegex',
    'invalidStartEndYears': 'appDesignErrorInvalidStartEndYear',
    'missingPersonMapping': 'appDesignErrorMissingPersonMapping'
};

const adminFormSearchStatusDisplayOrder = [
    CONSTANTS.applicationFormFilterMode.editpublished,
    CONSTANTS.applicationFormFilterMode.draft,
    CONSTANTS.applicationFormFilterMode.archived,
];

const adminFormSearchTypeDisplayOrder = [
    applicationTemplateType.application,
    applicationTemplateType.aid,
    applicationTemplateType.inquiry,
    applicationTemplateType.supplemental,
];

const richTextEditorPlaceholders = [
    { id: 'first-name', label: 'richTextFieldPlaceholdersFirstName' },
    { id: 'last-name', label: 'richTextFieldPlaceholdersLastName' },
    { id: 'email', label: 'richTextFieldPlaceholdersEmail' },
    { id: 'phone-number', label: 'richTextFieldPlaceholdersPhoneNumber' },
    { id: 'academic-program', label: 'richTextFieldPlaceholdersAcademicProgram' },
    { id: 'academic-term', label: 'richTextFieldPlaceholdersAcademicTerm' },
];

const richTextEditorEmailSendPlaceholders = [
    { id: 'first-name', label: 'richTextFieldPlaceholdersFirstName' },
    { id: 'last-name', label: 'richTextFieldPlaceholdersLastName' },
    { id: 'email', label: 'richTextFieldPlaceholdersEmail' },
    { id: 'phone-number', label: 'richTextFieldPlaceholdersPhoneNumber' },
    { id: 'academic-program', label: 'richTextFieldPlaceholdersAcademicProgram' },
    { id: 'academic-term', label: 'richTextFieldPlaceholdersAcademicTerm' },
];
const applicantRoute = (route, applicationId, pageId = null) => {
    return route.replace(':id', applicationId).replace(':pageId', pageId);
};
const routes = {
    admin: '/admin',
    adminProspects: '/admin/prospects',
    adminProspectsRecord: '/admin/prospects/:id',
    adminTemplate: '/admin/template',
    adminTemplateById: '/admin/template/:id',
    adminTemplatePreview: '/admin/preview/:id',
    adminTemplatePreviewPageById: '/admin/preview/:id/page/:pageId',
    adminTemplatePreviewReviewPage: '/admin/preview/:id/review',
    adminTemplatePreviewSubmitPage: '/admin/preview/:id/submitted',
    adminTemplatePreviewSupplementalItemsPage: '/admin/preview/:id/supplementalitems',
    adminTemplatePreviewSupportingDocumentsPage: '/admin/preview/:id/supportingdocuments',
    applicationDesigner: '/appdesigner',
    applicationForm: '/applicant/application/:id',
    applicationFormPage: (id, pageId) => routes.applicationFormPageById.replace(':id', id).replace(':pageId', pageId),
    applicationFormPageById: '/applicant/application/:id/page/:pageId',
    applicationFormReviewPage: '/applicant/application/:id/review',
    applicationFormStart: '/applicant/application/:id/start',
    applicationFormStartWithId: id => routes.applicationFormStart.replace(':id', id),
    applicationFormSubmitPage: '/applicant/application/:id/submitted',
    applicationFormWithdrawnPage: '/applicant/application/:id/withdrawn',
    applicationFormSupplementalItemsPage: '/applicant/application/:id/supplementalitems',
    applicationFormSupportingDocumentsPage: '/applicant/application/:id/supportingdocuments',
    applicationFormPayments: '/applicant/application/:id/payments',
    applicationFormSupplementalForm: '/applicant/supplementalForm/:id',
    applicationShare: '/applicant/external/share/:id',
    externalApplication: '/applicant/external/share/:id',
    externalApplicationPageById: '/applicant/external/share/:id/page/:pageId',
    externalApplicationSubmitPage: '/applicant/external/share/:id/submitted',
    externalApplicationSupplementalItemsPage: '/applicant/external/share/:id/supplementalitems',
    externalApplicationSupportingDocumentsPage: '/applicant/external/share/:id/supportingdocuments',
    externalApplicationPayments: '/applicant/external/share/:id/payments',
    externalApplicationwReviewPage: '/applicant/external/share/:id/review',
    globalSettings: '/imports/settings',
    home: '/applicant',
    totp: '/applicant/auth',
    totpRecovery: '/applicant/auth/recovery',
    totpReset: '/applicant/auth/reset',
    totpResetConfirm: '/applicant/auth/reset/confirm',
    totpLostRecoveryCode: '/applicant/auth/lostrecoverycode',
    imports: '/imports',
    importsFraud: '/imports/fraud',
    importsProspects: '/imports/prospects',
    importsProspectsRecord: '/imports/prospects/:id',
    importsStagingErrorRecords: '/imports/errors',
    importsApplicationRecords: '/imports/applications',
    importsStagersRecord: '/imports/stagers/:id',
    importsTemplate: '/imports/template',
    importsTemplateById: '/imports/template/:id',
    importsTemplateStatus: '/imports/templatestatus',
    importsTemplatePreview: '/imports/preview/:id',
    importsTemplatePreviewPageById: '/imports/preview/:id/page/:pageId',
    importsTemplatePreviewReviewPage: '/imports/preview/:id/review',
    importsTemplatePreviewSupplementalItemsPage: '/imports/preview/:id/supplementalitems',
    importsTemplatePreviewSupportingDocumentsPage: '/imports/preview/:id/supportingdocuments',
    importsApiSettings: '/imports/settings/apikeys',
    importsInquiry: '/imports/inquiry',
    importsSettings: '/imports/settings',
    importsApplicationViewPage: '/imports/application/:id',
    importsApplicationEditPage: '/imports/editapplication/:id',
    importsApplicationEditPageById: '/imports/editapplication/:id/page/:pageId',
    importsTemplatePreviewSubmitPage: '/imports/preview/:id/submitted',
    importsTransferJob: '/imports/transferjob/:id',
    inquiry: '/applicant/inquiry',
    invalidApplicantLink: '/applicant/link/expired',
    invalidShareUrl: '/applicant/external/expired',
    newApplication: '/applicant/newapplication',
    placeholder: '/placeholder',
    uaeLogin: '/applicant/uae/login',
    uaeSignup: '/applicant/uae/signup',
    retrieval: '/applicant/retrieval',
    retrievalSubmitted: '/applicant/retrieval/submitted',
    reportsHome: '/admin/reports',
    reportsCommunications: '/admin/reports#communications',
    reportsErrorsAdmin: '/admin/reports#errorsadmin',
    reportsErrorsApplicant: '/admin/reports#errorsprospect',
    reportsErrorsIntegration: '/admin/reports#errorsintegration',
    reportsErrorsRecaptcha: '/admin/reports#errorsrecaptcha',
    reportsPayments: '/admin/reports#paymenttransactions',
    reportsSubmittedApplications: '/admin/reports#submittedapplications',
};

// We can change this to { [routes.retrieval]: routes.retrieval } once this is on ES
const homePageMap = (() => {
    const map = {};
    map[routes.retrieval] = routes.retrieval;
    map[routes.retrievalSubmitted] = routes.retrieval;
    map[routes.applicationFormPageById] = routes.applicationForm;
    map[routes.externalApplicationPageById] = routes.externalApplication;
    return map;
})();

const fieldIdMappings = {
    inquiryStatusId: 'd2059331-e361-4714-837f-2ffdfc6d9e9a',
};

const applicationTemplateSettingsToKeep = [
    'displayNameId',
    'externalDescriptionId',
    'inactiveFormMessageId',
    'inactiveFormPageTitleId',
    'maxSearchOptionsWarningTextId',
    'wizardTitleId',
    'confirmationDescriptionId',
    'emailSubjectId',
    'emailBodyId',
    'emailNotificationToggle',
    'senderEmail',
    'language',
    'importCode',
    'applicationTemplateType'
];

const adminRoutes = Object.values(routes)
    .filter(route => {
        // Lint was complaining that route.split isn't a function :(
        const parts = (route + '').split('/');

        return parts.length > 1 && parts[1] == 'admin';
    });

module.exports = {
    adminFormSearchStatusDisplayOrder,
    adminFormSearchTypeDisplayOrder,
    fieldIdMappings,
    richTextEditorPlaceholders,
    richTextEditorEmailSendPlaceholders,
    routes,
    adminRoutes,
    homePageMap,
    applicantRoute,
    validationErrorType,
    settingsType,
    templateErrorMessages,
    CONSTANTS,
    DA_LIST_MAX_ROWS,
    validHedmAttributeTypesByControlType,
    applicationTemplateSettingsToKeep
};
